import { Field } from "formik";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import FormContainer from "../../components/CustomForm/FormContainer";
import FormField from "../../components/CustomForm/FormField";
import CustomToast from "../../components/CustomToast";
import Loader from "../../utils/Loader";
import { getLocalStorageItem } from "../../utils/LocalStorage";
import {
  getMessageByIdService,
  updateMessageByIdService,
} from "../../services/adminService";

const EditMessage = () => {
  const [message, setMessage] = useState({});
  const [loading, setLoading] = useState(false);

  const { state } = useLocation();
  const { id } = state;
  const token = getLocalStorageItem();

  const getMessage = async () => {
    setLoading(true);
    try {
      const { data } = await getMessageByIdService(id, token);
      if (data.data) setMessage(data.data);
    } catch (error) {
      CustomToast("err", error?.response?.data?.message || error?.message);
    }
    setLoading(false);
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const { data } = await updateMessageByIdService(id, token);
      if (data.data) CustomToast("success", data.data);
    } catch (error) {
      CustomToast("err", error?.response?.data?.message || error.response);
    }
    setLoading(false);
  };

  useEffect(() => {
    getMessage();
    return () => {
      setMessage({});
    };
  }, []);
  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <FormContainer
          buttonTitle={"Resolve"}
          width={"w-[90%] md:w-[50%] "}
          handleSubmit={handleSubmit}
          initialValues={{
            email: message?.email ?? "",
            message: message?.message ?? "",
            createdAt: message.createdAt ?? "",
          }}
        >
          <FormField
            label="Email"
            name="email"
            width={"w-[90%]  md:px-5 my-1"}
            disabled={true}
            isLogin={true}
          ></FormField>
          <FormField
            label="Your message"
            name="message"
            disabled={true}
            as="textarea"
            cols={"10"}
            rows={"10"}
            width={"w-[90%]  md:px-5 my-1"}
            isLogin={true}
          ></FormField>

          <p className="w-[90%] md:px-5 p-2 my-2 text-[#4D5959] text-left">
            Requested on
          </p>
          <Field
            disabled={true}
            className="w-[90%] md:px-5 my-1 outline-[#99d5e9] rounded-md p-2 bg-[#EFF0F2]"
            value={new Date(message.createdAt).toDateString()}
          ></Field>
        </FormContainer>
      )}
    </div>
  );
};

export default EditMessage;
